type TaskAccessMetadata = {
  assignee?: string | null;
  assignee_id?: string | null;
  state?: string | null;
};

type CurrentUser = {
  id?: string | null;
  name?: string | null;
};

export function isTaskSaveConflictStatus(status: unknown): boolean {
  return status === 404 || status === 403 || status === 409;
}

export function isTaskReadOnly(
  task: TaskAccessMetadata,
  currentUser: CurrentUser,
  completedState: string,
): boolean {
  if (task.state === completedState) return true;
  if (task.assignee_id) return task.assignee_id !== currentUser.id;
  return !task.assignee || task.assignee !== currentUser.name;
}
